<script lang="ts">
  const sizes = {
    big: "h-14 w-14",
    small: "h-10 w-10",
    xs: "h-8 w-8",
  };

  const variants = {
    purple: "border-PurplePrimary",
    white: "border-white",
  };

  import { onDestroy } from "svelte";
  interface Props {
    size?: keyof typeof sizes;
    variant?: keyof typeof variants;
    children?: import('svelte').Snippet;
  }

  let { size = "big", variant = "purple", children }: Props = $props();
  let show = $state(false);
  const timeoutId = setTimeout(() => (show = true), 400);
  onDestroy(() => clearTimeout(timeoutId));
</script>

{#if show}
  <div
    style="border-top-color:transparent;"
    class="border-4 flex-shrink-0 opacity-80  border-solid rounded-full animate-spin {sizes[
      size
    ]} {variants[variant]}"
></div>
  {@render children?.()}
{/if}
